module.exports = __webpack_public_path__ + "img/asr-logo-03.975a97d1.png";